import React from 'react';
import { adBlockElName } from '@gik/ads/components/AdContainer';

export default function FallbackAd() {
  return (
    <a href="/create" target="_blank">
      <div className={adBlockElName} />
    </a>
  );
}
